import { IconButton, Link, Stack, Typography } from "@mui/material"
import { OpenInNew as LinkIcon } from '@mui/icons-material'
import { useMemo, useState } from "react"
import { ClampTypography } from "components/controls/clampTypography"

type MultiRowCellProps = {
	value: string | number
	direction?: 'vertical' | 'horizon'
	maxRow?: number
}
const MultiRowCell = ({
	value,
	direction,
	maxRow
}: MultiRowCellProps) => {
	const [open, setOpen] = useState<boolean>(false)
	const rows = useMemo(
		() => {
			if (typeof value !== 'string') return []
			if (value === '') return []
			return value?.split('\n').map(line => line.replace(/\t/g, ' '))
		},
		[value]
	)
	return (
		<>
			<Stack direction={direction === 'horizon' ? 'row' : 'column'} flexWrap="wrap" useFlexGap>
				{((open || maxRow === undefined) ? rows : rows.slice(0, maxRow)).map((row, i) => (
					<Typography
						key={`row-${i}`}
						component="div"
						variant="body2"
						marginRight={direction === 'horizon' ? 1 : 0}
					>
						{row}
					</Typography>
				))}
			</Stack>
			{(maxRow !== undefined && rows.length > maxRow) ? (
				<Link
					underline="hover"
					component="button"
					variant="body2"
					onClick={
						(ev) => {
							ev.stopPropagation()
							setOpen(!open)
						}
					}
				>
					{open ? "閉じる" : `すべて表示(${rows.length})`}
				</Link>
			) : <></>}
		</>
	)
}

export const renderer = {
	name: (value: string | number) => {
		if (typeof value !== 'string') return <></>
		if (value === '') return <></>
		const at = value.indexOf('\n')
		if (at < 0) return <div>{value}</div>

		const kana = value.substring(0, at)
		const kanji = value.substring(at + 1)
		return <ruby>
			{kanji}
			<rt>{kana}</rt>
		</ruby>
	},
	nameKanji: (value: string | number) => {
		if (typeof value !== 'string') return <></>
		if (value === '') return <></>
		const at = value.indexOf('\n')
		if (at < 0) return <div>{value}</div>
		const kanji = value.substring(at + 1)
		return <div>{kanji}</div>
	},
	multiRow: (value: string | number, direction?: 'vertical' | 'horizon', maxRow?: number) => {
		return <MultiRowCell value={value} direction={direction} maxRow={maxRow}/>
	},
	clampText: (value: string | number, clampRow?: number) => {
		return <ClampTypography text={typeof value === 'string' ? value : `${value}`} clampRow={clampRow}/>
	},
	url: (value: string | number) => {
		if (typeof value !== 'string') return <></>
		if (value === '') return <></>
		return (
			<IconButton
				size="small"
				href={value}
				target="_blank"
				sx={{ margin: -1 }}
			>
				<LinkIcon fontSize="small"/>
			</IconButton>
		)
	}
}
